import { render, staticRenderFns } from "./ItemSelect.vue?vue&type=template&id=1a491d32&scoped=true"
import script from "./ItemSelect.vue?vue&type=script&lang=js"
export * from "./ItemSelect.vue?vue&type=script&lang=js"
import style0 from "./ItemSelect.vue?vue&type=style&index=0&id=1a491d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a491d32",
  null
  
)

export default component.exports